import { render, staticRenderFns } from "./StaffListView.vue?vue&type=template&id=8cb20b0a&scoped=true"
import script from "./StaffListView.vue?vue&type=script&lang=js"
export * from "./StaffListView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cb20b0a",
  null
  
)

export default component.exports